import { forwardRef } from 'react';

import { twMerge } from 'tailwind-merge';

import { PASSWORD_VALIDATORS_RULES } from '../../../config';
import { PasswordRuleItem } from './PasswordRuleItem';
import { IPasswordRules } from './types';

export const PasswordRules = forwardRef<HTMLDivElement, IPasswordRules>(
  ({ value, className }, ref) => {
    return (
      <div
        ref={ref}
        className={twMerge(
          'rounded-[16px] bg-surface-01 p-4 text-left',
          className,
        )}
      >
        <p className="mb-[14px] headline-5">Password must include</p>

        <ul className="flex flex-col gap-1">
          {PASSWORD_VALIDATORS_RULES.map(({ label, checkValidRule }) => (
            <PasswordRuleItem
              key={label}
              label={label}
              checkValidRule={checkValidRule}
              value={value}
            />
          ))}
        </ul>
      </div>
    );
  },
);
